function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#282828;}\n\t.st1{fill:#FFFFFF;}\n");

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "bb4f8c91-a67b-4b5f-8b8d-10a60f18869a"
}, /*#__PURE__*/React.createElement("g", {
  id: "fc9febf0-13f1-4df3-847c-3738c216880d"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "a79e3b5c-b7ca-4345-a71b-2babe9dcd2e0",
  className: "st0",
  cx: 51.2,
  cy: 50.4,
  rx: 51,
  ry: 50.5
}))), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M64.3,57.1H62l-0.8-0.8c2.9-3.4,4.7-7.8,4.7-12.6c0-10.7-8.6-19.3-19.3-19.3s-19.3,8.6-19.3,19.3 S35.9,63,46.5,63c4.8,0,9.2-1.8,12.6-4.7l0.8,0.8v2.3l14.8,14.8l4.4-4.4L64.3,57.1z M46.5,57.1c-7.4,0-13.4-6-13.4-13.4 s6-13.4,13.4-13.4s13.4,6,13.4,13.4S53.9,57.1,46.5,57.1z"
}));

const SvgOpen = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Ebene_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 102 101",
  style: {
    enableBackground: "new 0 0 102 101"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOpen, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/open.f90b3fda.svg";
export { ForwardRef as ReactComponent };